import React, { useEffect, useState } from 'react'
import { HTTP } from '../../../../api/resources'
import ToggleSwitch from '../../../ToggleSwitch/ToggleSwitch'

export default function PurchasePlan({plan, end_date, close = false, onInit = false, team}) {
    const [headerMessage, setHeaderMessage] = useState('')
    const [selectedPlan, setSelectedPlan] = useState('none')
    const [additionalProfiles, setAdditionalProfiles] = useState(100)
    const [hideModal, setHideModal] = useState(false)
    const [saving, setSaving] = useState(false)
    const [warningMessage, setWarningMessage] = useState('')
    const [purchaseDomain, setPurchaseDomain] = useState(false)

    let domainPricing = team.use_custom_pricing ? team.add_on_cost : 100 
    let grassrootPlan = team.use_custom_pricing ? team.grassroot_plan : 30 
    let enterprisePlan = team.use_custom_pricing ? team.enterprise_plan : 30 
    let profileCost = team.use_custom_pricing ? team.profile_cost : 5

    useEffect(() => {
        if (plan.name == 'Free Trial') {
            setHeaderMessage(
                `You are currently on free trial which will end on ${end_date}, you can purchase a plan now, your plan will 
                only take effect after the free trial as ended`
            )
        }

        if (plan.name == 'Start Up') {
            setHeaderMessage(
                `You are currently on Start Up plan which it completely free, purchase a paid plan to have access to powerful 
                features and automations`
            )
        }

        if (plan.name !== 'Start Up' && plan.name !== 'Free Trial') {
            setHeaderMessage(
                `You are currently on ${plan.name} plan and your next billing will be on ${end_date}, you can upgrade your 
                plan for better experience`
            )
        }
    }, [])

    useEffect(() => {
        if (selectedPlan == 'Enterprise') {
            if (additionalProfiles < 100) {
                setWarningMessage('Additional profiles cannot be less than 100')
                return
            }

            if (additionalProfiles % 100 !== 0) {
                setWarningMessage('Additional profiles needs to be in increments of 100')
                return
            }

            setWarningMessage('')
        }
    }, [additionalProfiles])

    const handleSubmit = async () => {
        setSaving(true)

        try {
            let response = await submitRequest()
            response = response.data
            if (response.action == 'redirect') {
                Alert.show('notice', response.notice)
                setTimeout(() => window.location.reload(), 1500)
            } else if (response.action == 'checkout') {
                Alert.show('notice', 'Redirecting to secure checkout')
                setTimeout(() => window.location = response.url, 1500)
            }
            setSaving(false)
        } catch {
            Alert.show('error', 'Error processing your request, please try again later')
            setSaving(false)
        }
    }

    const submitRequest = () => {
        return HTTP.post('/team/plan', {profile: additionalProfiles, plan: selectedPlan, domain: purchaseDomain})
    }

    const handleCloseModal = () => {
        if (onInit) {
            setHideModal(true)
            return
        }

        close()
    }

    const getTotalAmount = () => {
        if (selectedPlan == 'Grassroot') {
            if (purchaseDomain) return domainPricing + grassrootPlan
            return grassrootPlan
        }
        if (selectedPlan == 'Enterprise') {
            let profileUnits = additionalProfiles / 100
            let amount = profileUnits * profileCost
            if (purchaseDomain) return enterprisePlan + domainPricing + amount
            return enterprisePlan + amount
        }
        if (purchaseDomain) return domainPricing
        return 0
    }

    const showGrassroot= () => {
        // do not show when plan is a grassroot or enterprise
        if (plan.next_billing && (plan.next_billing.name == 'Grassroot' || plan.next_billing.name == 'Enterprise')) {
            return false
        }

        if (plan.active && (plan.name == 'Grassroot' || plan.name == 'Enterprise')) {
            return false
        }

        return true
    }
    
    const showEnterprise = () => {
        // do not show when plan is a grassroot or enterprise
        if (plan.next_billing && plan.next_billing.name == 'Enterprise') {
            return false
        }

        if (plan.name == 'Enterprise' && plan.active) {
            return false
        }

        return true
    }

  return (
    <div>
        {!hideModal &&
    <div className="align-content-center align-items-center animated d-flex fadeIn h-100 justify-content-center position-fixed w-100 line-item-modal">
        <div className="bg-white mx-auto rounded shadow p-5 text-center">
            <h2>Purchase Plan</h2>
            <p>
                {headerMessage}
            </p>

            <div className='row justify-content-center'>
                {showGrassroot() && 
                    <div className='col-12 col-md-6 col-lg-4'>
                        <div className='card'>
                            <div className='card-body'>
                                <div>
                                    <h3>Grassroot</h3>
                                    <p>For Small Non-profit Teams</p>
                                </div>
                                <div >
                                    <h4><b>${ grassrootPlan }</b>/month</h4>
                                </div>
                                <div>
                                    <p>Up to 200 Profiles</p>
                                    <p>All Features</p>
                                    <p>No Hidden Fees</p>
                                </div>
                                <div>
                                    <button 
                                        onClick={() => {
                                            setSelectedPlan('Grassroot')
                                            setWarningMessage('')
                                        }} 
                                        disabled={selectedPlan == 'Grassroot'} 
                                        className='btn btn-primary'
                                    >
                                        {selectedPlan == 'Grassroot' && <>Selected</>}
                                        {selectedPlan !== 'Grassroot' && <>Select</>}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                }

                {showEnterprise() &&
                    <div className='col-12 col-md-6 col-lg-4'>
                        <div className='card'>
                            <div className='card-body'>
                                <div>
                                    <h3>Enterprise</h3>
                                    <p>For Large Non-profit Teams</p>
                                </div>
                                <div >
                                    <h4><b>${ enterprisePlan }+</b>/month</h4>
                                </div>
                                <div>
                                    <p>200+ Profiles</p>
                                    <p>Custom solutions</p>
                                    <p>No Hidden Fees</p>
                                </div>
                                <div>
                                    <button onClick={() => setSelectedPlan('Enterprise')} disabled={selectedPlan == 'Enterprise'} className='btn btn-primary'>
                                        {selectedPlan == 'Enterprise' && <>Selected</>}
                                        {selectedPlan !== 'Enterprise' && <>Select</>}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                }
            </div>
            
            {!team.purchased_custom_domain &&
                <div className="form-group">
                    <ToggleSwitch
                        small
                        id="show_sponsor_send_message"
                        checked={purchaseDomain}
                        onChange={checked => {
                            setPurchaseDomain(checked)
                        }}
                    />
                    <label htmlFor="show_sponsor_send_message">
                        Purchase the custom domain add on (one-time payment)
                    </label>
              </div>
            }
            {selectedPlan == 'Enterprise' &&
                <div>
                    <h3>Purchase Additional Profiles</h3>
                    <p>
                        Enterprise plan by default provides you with 200+ profiles (includes Donor, Beneficiary, Project), you can purchase
                        additional profiles to increase your profile limit
                    </p>

                    <div>
                        <div className="form-group rd-pad-in">
                            <label className='profile'>Additional Profiles (increment of 100)</label>
                            <input 
                                type='number'
                                step={100}
                                className='form-control'
                                id='profile'
                                value={additionalProfiles}
                                onChange={(e) => {
                                    setAdditionalProfiles(e.target.value)
                                }}
                            />
                        </div>
                        <small className='text-danger'>{warningMessage}</small>
                    </div>
                </div>
            }

            <h4>Total Amount: ${ parseFloat(getTotalAmount()).toFixed(2) } USD</h4>

            <div className="pt-3">
                <button onClick={handleSubmit} type="button" className="btn btn-primary mr-2" disabled={saving || warningMessage.length > 0 || selectedPlan == 'none'}>
                {saving && <i className="fa fa-spinner-third fa-spin mr-2"></i>}
                    Proceed
                </button>

                <button onClick={handleCloseModal} type="button" className="btn btn-danger mr-2" disabled={saving}>
                    Cancel
                </button>
            </div>
        </div>
    </div>
}
    </div>
  )
}
